<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">文章修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="标题" required prop="infoTitleCode">
                                    <el-select v-model="editForm.infoTitleCode" placeholder="选择标题" style="width:100%" >
                                        <el-option
                                                v-for="item in InfoTitleList"
                                                :key="item.infoTitleCode"
                                                :label="item.title"
                                                :value="item.infoTitleCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="简介" required prop="description">
                                    <el-input v-model="editForm.description" type="textarea"  placeholder="请输入简介"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="详情" required prop="detail">
                                    <Quill1 placeholder='请输入详情' v-model='editForm.detail' editorRef='editQuill' @input="handelIncrease"></Quill1>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
        
    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {getStaffCode} from "@/utils/auth";
    import Quill1 from "@/components/Quill";
    import {hex_md5} from "@/common/Base64MD5";
   
    export default {
        name: "Edit",
        props:['InfoTitleList'],
        data() {
            return {
                loading: false,
                imageUrl:"",
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    infoCode:'',
                    infoTitleCode:'',
                    description:'',
                    detail:'',
                },
                rules:{
                    infoTitleCode:[
                        { required: true, message: '请选择标题', trigger: 'blur' },
                    ],
                    description:[
                        { required: true, message: '请输入描述', trigger: 'blur' },
                    ],
                    detail:[
                        { required: true, message: '请输入详情', trigger: 'blur' },
                    ],

                }
            }
        },
        components:{
            Quill1
        },
        methods: {
            init(row){
                this.editForm.infoCode=row.infoCode
                this.editForm.infoTitleCode=row.infoTitleCode
                this.editForm.description=row.description
                this.editForm.detail=row.detail
            },

            closeSelf() {
                this.$emit("closeEdit");
            },
            handelIncrease(step) {
                this.editForm.detail=step
            },
            
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            addSubmit(){
                this.loading = true;
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Info/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }
</script>

<style  lang="scss" scoped>
    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
    .modal {
        background-color: #fff;
        box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 700px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 0px;
        z-index: 99;
        overflow-y:scroll ;
        height: 400px;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>